import { Badge, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

const STATUSES = {
  new: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'benchmarks::list.statuses.new',
  },
  archived: {
    icon: 'inbox-archive',
    color: 'Label-Fifth',
    bgColor: 'Background-Quaternary',
    label: 'benchmarks::list.statuses.archived',
  },
}

export const StatusBadge = ({ status = null, ...rest }) => {
  const currentStatus = STATUSES?.[status]
  const { t } = useTranslation()

  if (!currentStatus) {
    return null
  }

  const { icon, label, bgColor, color } = currentStatus

  return (
    <Badge
      {...rest}
      size={'xs'}
      variant={'Body-10'}
      bgColor={bgColor}
      color={color}
      startIcon={
        <Icon
          color={color}
          name={icon}
          width={16}
        />
      }
    >
      {t(label)}
    </Badge>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
}
